export default class TicketTemplateMapSettingController {
    constructor($scope, $injector, $element) {
        this.scope = $scope;
        this.injector = $injector;
        this.element = $element;

        this.definitionInformation = null;
        this.currentModel = null;
        this.onModelUpdate = () => {
        };

        this.internalModel = null;

        this.googleMap = null;
        this.googleAutoComplete = null;
        this.googleDrawingManager = null;
        this.googleMarkers = [];

        this.addMarkerActive = false;
    }

    $onInit() {
        this.internalModel = this._transformInModel();

        this._initGoogleMap();
        this._initWatchers();
    }

    updateMarkerColor(marker, newColor) {
        marker.color = newColor.hex;
    }

    startAddMarker() {
        this.googleDrawingManager.setDrawingMode('marker');
        this.addMarkerActive = true;
    }

    cancelAddMarker() {
        this.googleDrawingManager.setDrawingMode(null);
        this.addMarkerActive = false;
    }

    removeMarker(marker) {
        const index = this.internalModel.markers.indexOf(marker);

        if (index === -1) {
            return;
        }

        const googleMarker = this.googleMarkers[index];
        googleMarker.setMap(null);
        this.googleMarkers.splice(index, 1);
        this.internalModel.markers.splice(index, 1);
    }

    centerMapToMarker(marker) {
        const index = this.internalModel.markers.indexOf(marker);

        if (index === -1) {
            return;
        }

        const googleMarker = this.googleMarkers[index];
        this.googleMap.setCenter({
            lat: googleMarker.position.lat(),
            lng: googleMarker.position.lng()
        });
    }

    _transformInModel() {
        return _.defaultsDeep(
            _.cloneDeep(this.currentModel),
            {
                markers: [],
                center: {
                    lat: 0,
                    lng: 0
                },
                zoom: 15,
                size: {
                    width: 400,
                    height: 250
                }
            }
        );
    }

    _transformOutModel() {
        const outModel = _.cloneDeep(this.internalModel);

        outModel.markers = _.map(outModel.markers, (marker) => {
            return {
                size: marker.size,
                label: marker.label,
                color: marker.color,
                lat: marker.lat,
                lng: marker.lng
            }
        });

        return outModel;
    }

    _updateModel() {
        this.onModelUpdate({
            newValue: this._transformOutModel()
        })
    }

    _initGoogleMap() {
        this.googleMap = new google.maps.Map(this.element.find('.map-container')[0], {
            zoom: this.internalModel.zoom,
            center: new google.maps.LatLng(this.internalModel.center.lat, this.internalModel.center.lng),
            mapTypeId: this.internalModel.map_type,
            zoomControl: true,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            mapTypeControl: true,
            disableDefaultUI: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DROPDOWN_MENU
            }
        });

        this.googleMap.addListener('center_changed', (event) => {
            this.internalModel.center = {
                lat: this.googleMap.center.lat(),
                lng: this.googleMap.center.lng()
            };
            this._updateModel();
        })

        this.googleMap.addListener('zoom_changed', (event) => {
            this.internalModel.zoom = this.googleMap.zoom;
            this._updateModel();
        })

        this.googleMap.addListener('maptypeid_changed', (event) => {
            this.internalModel.map_type = this.googleMap.mapTypeId;
            this._updateModel();
        })

        this._initMarkers();
        this._initDrawingManager();
        this._initAutoComplete();
    }

    _initAutoComplete() {
        const searchBoxElement = this.element.find('.map-autocomplete')[0];

        this.googleAutoComplete = new google.maps.places.SearchBox(searchBoxElement, {});

        google.maps.event.addDomListener(searchBoxElement, 'keydown', function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
            }
        });

        this.googleAutoComplete.addListener('places_changed', () => {
            const places = this.googleAutoComplete.getPlaces();

            if (places.length === 0) {
                return;
            }

            const position = {
                lat: places[0].geometry.location.lat(),
                lng: places[0].geometry.location.lng()
            };

            if (this.addMarkerActive) {
                const markerIndex = this.internalModel.markers.length;

                const newMarkerInfo = {
                    ...position,
                    color: '#9C63FF',
                    label: searchBoxElement.value[0],
                    size: ''
                };
                this._addMarkerToMap(markerIndex, newMarkerInfo);
                this.internalModel.markers[markerIndex] = newMarkerInfo;
                this.cancelAddMarker();
                this._checkIfMarkersInViewPortOtherwiseResize();

                this.scope.$applyAsync();
            } else {
                this.googleMap.setCenter(position);
            }

            searchBoxElement.value = '';
        });
    }

    _checkIfMarkersInViewPortOtherwiseResize() {
        let allMarkersIn = true;
        const bounds = new google.maps.LatLngBounds();

        _.each(this.googleMarkers, (marker) => {
            const markerPos = marker.getPosition();
            bounds.extend(markerPos);
            if (!this.googleMap.getBounds().contains(markerPos)) {
                console.log('marker not in bounds', marker);
                allMarkersIn = false;
            }
        })

        if (!allMarkersIn) {
            this.googleMap.fitBounds(bounds);
        }
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.internalModel.markers,
            () => {
                this._updateModel();
                this._updateMarkersOnMap();
            },
            true
        );
    }

    _initMarkers() {
        _.each(this.internalModel.markers, (marker, index) => {
            this._addMarkerToMap(index, marker);
        });
    }

    _updateMarkersOnMap() {
        _.each(this.internalModel.markers, (marker, index) => {
            this._updateMarkerOnMap(index);
        });
    }

    _updateMarkerOnMap(index) {
        const markerInfo = this.internalModel.markers[index],
            marker = this.googleMarkers[index];

        if (markerInfo.lat !== marker.position.lat() || markerInfo.lng !== marker.position.lng()) {
            marker.setPosition(new google.maps.LatLng(markerInfo.lat, markerInfo.lng));
        }
        marker.setLabel(markerInfo.label);
    }

    _addMarkerToMap(index, markerInfo) {
        const newMarker = new google.maps.Marker({
            position: new google.maps.LatLng(markerInfo.lat, markerInfo.lng),
            map: this.googleMap,
            label: markerInfo.label,
            draggable: true
        });

        newMarker.addListener('dragend', () => {
            markerInfo.lat = newMarker.position.lat();
            markerInfo.lng = newMarker.position.lng();
        })

        this.googleMarkers[index] = newMarker;
    }

    _initDrawingManager() {
        const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: false,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: ['marker'/*, 'circle', 'polygon', 'polyline', 'rectangle'*/]
            }
        });
        drawingManager.setMap(this.googleMap);

        this.googleDrawingManager = drawingManager;

        google.maps.event.addListener(drawingManager, 'markercomplete', (marker) => {
            const markerIndex = this.googleMarkers.length;
            this.googleMarkers[markerIndex] = marker;

            this.internalModel.markers[markerIndex] = {
                lat: marker.position.lat(),
                lng: marker.position.lng(),
                color: '#9C63FF',
                label: '',
                size: ''
            };
            this.cancelAddMarker();
            this._checkIfMarkersInViewPortOtherwiseResize();
            this.scope.$applyAsync();
        });
    }
}

TicketTemplateMapSettingController.$inject = [
    '$scope',
    '$injector',
    '$element'
];



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/components/al-ticket-template-map-setting/controller.js